import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Couimg from "../assets/img/footer_logo2.svg";
import Image1 from "../assets/img/footer_logo2.svg";
import Image2 from "../assets/img/footer_logo2.svg";
import Image3 from "../assets/img/footer_logo2.svg";
import Image4 from "../assets/img/footer_logo2.svg";
import Image5 from "../assets/img/footer_logo2.svg";

import Video1 from '../assets/img/play.png';
import Video2 from '../assets/img/play.png';
import Video3 from '../assets/img/play.png';
import Video4 from '../assets/img/play.png';
import Gmailicon from '../assets/img/gmail.png';
import Phoneicon from '../assets/img/phone.png';
import Playbtn from '../assets/img/play.png';
import { Helmet } from "react-helmet-async";

const Coursessingle = () => {
  const { id } = useParams();

const [activeVideo, setActiveVideo] = useState(null);
const [formData, setFormData] = useState({
  name: "",
  email: "",
  phone: ""
}); 

    
      const handleOpenModal = (videoSrc) => {
        setActiveVideo(videoSrc); // Set the active video source
      };
    
      const handleCloseModal = () => {
        setActiveVideo(null); // Clear the active video source
      };

     


      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
      };

       
    
      const handleRazorpayPayment = async (courseType) => {
  if (!formData.name.trim()) {
    alert("Please enter your name.");
    return;
  }
  if (!formData.email.trim()) {
    alert("Please enter your email.");
    return;
  }
  if (!formData.phone.trim()) {
    alert("Please enter your phone number.");
    return;
  }

  const amount = courseType === "online" ? 50000 : courseType === "offline" ? 100000 : 200000;
  const description = courseType === "online" ? "Online Course" : courseType === "offline" ? "Offline Course" : "Only Offline Course";

  // 1. Create Razorpay Order from your PHP
  let orderId = null;
  try {
    const response = await fetch("https://thebhavanasingh.com/create_order.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ amount: amount * 100 }) // amount in paise
    });
    const data = await response.json();

    console.log("Create Order Response:", data);

    if (!data || !data.id) {
      alert("Failed to create Razorpay order.");
      return;
    }

    orderId = data.id;
  } catch (error) {
    console.error("Order creation error:", error);
    alert("Something went wrong while creating the order.");
    return;
  }

  // 2. Open Razorpay Checkout
  const options = {
    key: "rzp_live_meaLkJIwJaMl5q", // Your Razorpay Key ID
    amount: amount * 100,
    currency: "INR",
    name: "Bhavana Singh Courses",
    description: description,
    order_id: orderId, // ✅ VERY IMPORTANT
    prefill: {
      name: formData.name,
      email: formData.email,
      contact: formData.phone,
    },
    notes: {
      address: "Bhavana Singh",
    },
    theme: {
      color: "#3399cc",
    },
    handler: function (response) {
      console.log("Payment Success Response:", response);
      window.location.href = `/success?payment_id=${response.razorpay_payment_id}`;
    },
  };

  const razorpay = new window.Razorpay(options);

  razorpay.on("payment.failed", function (response) {
    console.error("Payment Failed:", response.error);
    alert(`Payment failed: ${response.error.description}`);
  });

  razorpay.open();
};
      


  const courses = {
    1: { title: "First Post",  meta: {
        title: "Bhavana Singh | Personality Transformation Coach",
        description: "Hi, I'm Bhavana Singh! I am a personality Transformation Coach who helps you shine and be the best version of yourself.",
        keywords: "Personal Transformation Coach, personality coach fashion coach"
      }, content: ( 
      <>
      <section class="courses_details">
        <div class="container">
            <div class="row">
                <div class="col-md-6 d-flex align-items-center">
                    <div class="courses_content">
                        <h3>TRANSFORM YOURSELF WITH Bhavana SINGH | ONLINE COURSE</h3>
                        <h2>Introduction</h2>
                        <p>This exclusive program offers a transformative journey, guiding you to build unshakable confidence, refine body language, and develop impactful public speaking skills. Going beyond style, it’s designed to elevate your presence in any setting—whether corporate, social, or personal. From mastering how to command attention in any crowd to curating a look that’s authentically yours in both Indian and Western wear, each session delivers high-level, hands-on insights to perfect every detail of your appearance. This is an investment in your most polished, empowered self.</p>
                        <div class="listcontent">
                            <div class="accordion" id="accordionExample">
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header" id="headingOne" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                  What to Expect
                                </h4>
                                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                  <p>Interactive experience through daily workshops that cover everything from boosting your confidence and expressing yourself with poise and ease. Gain essential skills to master a corporate look. </p>
                                  </div>
                                </div>
                              </div>
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header collapsed" id="headingTwo" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                 
                                  Who is it for
                                  
                                </h4>
                                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                  <p>This workshop is perfect for anyone ready to boost their confidence and enhance their presence. It is ideal for:</p>
                                  <ul>
                                    <li><b>Professionals</b> - Looking to refine their influence and make a lasting impact in their careers.</li>
                                    <li><b>Homemakers</b> - Ready to step into a more confident and empowered version of themselves.</li>
                                    <li><b>Aspiring Designers & Stylists</b> - Eager to elevate their style and build a successful career in fashion.</li>
                                    <li><b>Influencers & Glam Industry Aspirants</b> - Seeking to improve their public presence and stand out in the media world.</li>
                                    <li><b>Anyone</b> - Committed to personal transformation and becoming the best version of themselves.</li>
                                  </ul>
                                  </div>
                                </div>
                              </div>
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header collapsed" id="headingThree" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                 
                                  What does it include
                                  
                                </h4>
                                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                  <p>This 7-day transformative online training program is packed with actionable insights and expert guidance to help you build a strong, confident personality. Here’s what’s covered: </p>
                                  <ul>
                                    <li><b>Day 1: Introduction to Personality</b> - Learn the basics of personality transformation.</li>
                                    <li><b>Day 2: Stand Out</b> - Discover how to get noticed.</li>
                                    <li><b>Day 3: Personal Style</b> - Find and express your unique style.</li>
                                    <li><b>Day 4: Indian Wear</b> - Master the art of styling Indian wear.</li>
                                    <li><b>Day 5: Makeup and Skincare</b> - Learn self-glam makeup and skincare routines.</li>
                                    <li><b>Day 6: Corporate Look</b> - Build a polished and professional look.</li>
                                    <li><b>Day 7: Body Language</b> - Enhance your presence with body language.</li>
                                  </ul>
                                  <p>This course will leave you feeling more confident, polished, and ready to take on the world!</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="courses_image">
                        <img src={Couimg} alt="" width="100%"/>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <section class="courses_sli">
        <div class="container">
            <div class="courses-slide">
                <div class="slide_head">
                    <h3>TRANSFORMATION IN FOCUS </h3>
                    <h2>Sneak Peek and Success Stories</h2>
                    <p>Get a firsthand look at the journey with real moments captured from our live sessions. Watch as confidence builds, style transforms, and true presence unfolds. These reels offer a glimpse into the powerful impact of our program in action.</p>
                </div>
            </div>
            <div class="swiper coursesslide">
            <div class="swiper-wrapper">
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video1)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image1}/><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video2)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image2}/><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video3)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image3}/><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video4)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image4}/><img className='playbtnv' src={Playbtn}></img></a></div>
                   
                </div>
            </div>
            <div class="courses_btn">
                <a href="#" data-bs-toggle="modal" data-bs-target="#onlineCourseModal">Enrol Now</a>
                <a href="https://drive.google.com/file/d/13HVh-gcpbu0lp-pKyRGex1xC3aTreI99/view">Download Brochure</a>
            </div>
        </div>
      </section>
      </>
      ), },
    2: { title: "Second Post",  meta: {
        title: "Bhavana Singh | Personality Transformation Coach",
        description: "Hi, I'm Bhavana Singh! I am a personality Transformation Coach who helps you shine and be the best version of yourself.",
        keywords: "Personal Transformation Coach, personality coach fashion coach"
      }, content: ( 
      <>
      <section class="courses_details">
        <div class="container">
            <div class="row">
                <div class="col-md-6 d-flex align-items-center">
                    <div class="courses_content">
                        <h3>Transform with Bhavana | Offline course</h3>
                        <h2>Introduction</h2>
                        <p>This transformative course is designed to equip you with the skills and knowledge to elevate your life both personally and professionally. From mastering your style and body language to building confidence and perfecting your communication, this program covers it all. Whether you’re looking to enhance your presence for interviews, boost your entrepreneurial journey, or refine your personal style, you will gain practical tools to unlock your fullest potential. Get ready for a complete transformation that empowers you to take on the world with confidence.</p>
                        <div class="listcontent">
                        <div class="accordion" id="accordionExample">
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header" id="headingOne" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                  What to Expect
                                </h4>
                                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                  <p>Expect a comprehensive journey of self-transformation, where you’ll enhance your style, confidence, and communication skills. This course offers hands-on experience, personalized guidance, and practical tools to help you excel in both personal and professional settings.</p>
                                  </div>
                                </div>
                              </div>
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header collapsed" id="headingTwo" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                 
                                  Who is it for
                                  
                                </h4>
                                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                  <p>This workshop is perfect for anyone ready to boost their confidence and enhance their presence. It is ideal for:</p>
                                  <ul>
                                    <li><b>Professionals</b> - Looking to refine their influence and make a lasting impact in their careers.</li>
                                    <li><b>Homemakers</b> - Ready to step into a more confident and empowered version of themselves.</li>
                                    <li><b>Aspiring Designers & Stylists</b> - Eager to elevate their style and build a successful career in fashion.</li>
                                    <li><b>Influencers & Glam Industry Aspirants</b> - Seeking to improve their public presence and stand out in the media world.</li>
                                    <li><b>Anyone</b> - Committed to personal transformation and becoming the best version of themselves.</li>
                                  </ul>
                                  </div>
                                </div>
                              </div>
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header collapsed" id="headingThree" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                 
                                  What does it include
                                  
                                </h4>
                                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                  <p>This comprehensive transformation program covers everything you need to elevate your personal and professional presence. Here's what you’ll gain: </p>
                                  <ul>
                                    <li><b>Head-to-Toe Transformation</b> - Master hair, makeup, styling, and shopping.</li>
                                    <li><b>Body Language & Confidence</b> - Learn poise, confidence, and powerful presence.</li>
                                    <li><b>Mall Visit</b> - Guided shopping with personalized fashion tips.</li>
                                    <li><b>Public Speaking</b> - Overcome fear and improve communication skills.</li>
                                    <li><b>Entrepreneurship</b> - Learn to start and run a successful business.</li>
                                    <li><b>How to Crack Interviews</b> - Master interview techniques and communication.</li>
                                    <li><b>Client Dealing</b> - Build effective client relationships and ensure satisfaction.</li>
                                    <li><b>Styling Improvement</b> - Enhance your personal and professional style.</li>
                                    <li><b>Self Makeup Glam</b> - Learn makeup techniques for a flawless look.</li>
                                    <li><b>Pleasant Personality</b> - Develop a pleasant and confident personality.</li>
                                    <li><b>Social Media</b> - Grow your social media presence.</li>
                                    <li><b>Body Shapes</b> - Dress according to your body shape.</li>
                                    <li><b>Men’s Styling</b> - Styling tips and techniques for men.</li>
                                    <li><b>Relationship Building</b> - Build and maintain professional relationships.</li>
                                    <li><b>Portfolio Building</b> - Create a standout portfolio to showcase your talents.</li>
                                    
                                  </ul>
                                  <p>This program will help you gain all the skills to present your best self in every aspect of life!</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="courses_image">
                        <img src={Couimg} alt="" width="100%"/>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <section class="courses_sli">
        <div class="container">
            <div class="courses-slide">
                <div class="slide_head">
                    <h3>TRANSFORMATION IN FOCUS </h3>
                    <h2>Sneak Peek and Success Stories</h2>
                    <p>Get a firsthand look at the journey with real moments captured from our live sessions. Watch as confidence builds, style transforms, and true presence unfolds. These reels offer a glimpse into the powerful impact of our program in action.</p>
                </div>
            </div>
            <div class="swiper coursesslide">
                <div class="swiper-wrapper">
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video1)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image1}/><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video2)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image2}/><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video3)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image3}/><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video4)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image4}/><img className='playbtnv' src={Playbtn}></img></a></div>
                   
                </div>
                <div>
                  <div className="testi-button-next swiper-button-next"></div>
                  <div className="testi-button-prev swiper-button-prev"></div>
                </div>
            </div>
            <div class="courses_btn">
                <a href="#" data-bs-toggle="modal" data-bs-target="#offlineCourseModal">Enrol Now</a>
                <a href="https://drive.google.com/file/d/1nxIrbeHU8anjk6qsMQL0-dQSJ1bhTEh6/view">Download Brochure</a>
            </div>
        </div>
      </section>
      
      </>
      ), },

      3: { title: "Second Post",  meta: {
        title: "Bhavana Singh | Personality Transformation Coach",
        description: "Hi, I'm Bhavana Singh! I am a personality Transformation Coach who helps you shine and be the best version of yourself.",
        keywords: "Personal Transformation Coach, personality coach fashion coach"
      }, content: ( 
      <>
      <section class="courses_details">
        <div class="container">
            <div class="row">
                <div class="col-md-6 d-flex align-items-center">
                    <div class="courses_content">
                        <h3>Transform With Bhavana – 2-Week Intensive Program Redefine Who You Are—Relaunch Where You’re Headed.</h3>
                        <h2>Introduction</h2>
                        <p>Led by renowned Personality & Image Transformation Coach Bhavana Singh, this premium 2-week offline course is a holistic program designed to help you step into your most confident, stylish, and impactful self. Whether you’re a professional seeking career elevation, an entrepreneur aiming to refine your image, or someone eager to launch a career in fashion, styling, or personal branding, this program is your launchpad.</p>
                        <p>You’ll walk away not just transformed in appearance, but empowered with real-world skills in communication, client handling, public presence, and digital branding. Most importantly, you’ll be ready to make a career, start your own business, or become an image consultant or transformation coach.</p>
                        <div class="listcontent">
                        <div class="accordion" id="accordionExample">
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header" id="headingOne" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                  What to Expect
                                </h4>
                                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                  <p>A fully immersive transformation journey that blends:</p>
                                   <ul>
                                    <li>Personality Development</li>
                                    <li>Confidence Building</li>
                                    <li>Styling & Grooming</li>
                                    <li>Business & Career Roadmap Creation</li>
                                  </ul>
                                  <p>Over 2 weeks, through intensive 4-hour daily sessions, you’ll experience live projects, one-on-one mentorship, role plays, fashion walk training, interview simulations, and social media growth tactics. This is not a classroom — it’s a real-world lab where your next version is born.</p>
                                  </div>
                                </div>
                              </div>
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header collapsed" id="headingTwo" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                 
                                  Who is it for
                                  
                                </h4>
                                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                  <p>This exclusive program is ideal for:</p>
                                  <ul>
                                    <li><b>Young Professionals</b> looking to build influence, improve communication, and fast-track their careers</li>
                                    <li><b>Homemakers</b> wanting to reinvent their identity and build confidence</li>
                                    <li><b>Fashion & Design Aspirants</b> eager to understand personal styling, trends, and industry expectations</li>
                                    <li><b>Social Media Influencers and Content Creators</b> and Content Creators ready to upgrade their brand and online presence</li>
                                    <li><b>Entrepreneurs & Coaches</b> ready to own the room and build powerful client relationships</li>
                                    <li><b>Anyone committed to real transformation</b> - inside out</li>
                                  </ul>
                                  </div>
                                </div>
                              </div>
                              <div class="accordion-item listitem">
                                <h4 class="accordiombr-header collapsed" id="headingThree" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                 
                                 What You’ll Learn
                                  
                                </h4>
                                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                  <div class="accordion-body">
                                  <p>WEEK 1: Core Personality &amp; Brand Foundation</p>

                                  <ul>
                                    <li>Advanced personality development</li>
                                    <li>Communication mastery for business and social settings</li>
                                    <li>Styling for personal brand identity (understanding your visual signature)</li>
                                    <li>Professional self-makeup &amp; camera-ready grooming</li>
                                    <li>Posture, gestures, and confident body language for public roles</li>
                                    <li>Fashion walk and media presence coaching</li>
                                    <li>Business etiquette, client interactions, and dining manners</li>
                                    <li>Personal branding essentials &mdash; defining what makes you unique</li>
                                  </ul>

                                  <p>By the end of Week 1, you&rsquo;ll not only feel transformed inside out &mdash; you&rsquo;ll also understand how to present yourself like a brand that sells.</p>

                                  <p>WEEK 2: Business, Monetisation &amp; Career Roadmap</p>

                                  <ul>
                                    <li>Social media positioning: crafting your online presence strategically</li>
                                    <li>Content creation for personal brand growth (including photography and video basics)</li>
                                    <li>Building mood boards and visual aesthetics for your brand voice</li>
                                    <li>Portfolio and resume development &mdash; what top clients/brands look for</li>
                                    <li>Working on live projects and client collaborations (hands-on exercises)</li>
                                    <li>Pitching yourself: how to approach brands, negotiate deals, and build partnerships</li>
                                    <li>Becoming a personal shopper or stylist for clients (with case exercises)</li>
                                    <li>Designing your business roadmap &mdash; including revenue streams, client handling, and scaling</li>
                                    <li>Post-course readiness: becoming a transformation coach, launching your own styling business, or creating a consulting career</li>
                                    <li>One-on-one mentorship and feedback to refine your path and vision</li>
                                  </ul>

                                  <p>Week 2 focuses on turning your personal growth into a profitable profession, giving you the strategy, systems, and structure to turn passion into purpose and income.</p>

                                  </div>
                                </div>
                              </div>
                              
                            </div>
                        </div>
                          <div className="progmbr">
                             <h3>Program Details</h3>
                              <ul>
                                <li>⏳Duratio: 2 Weeks | 4 Hours Daily (Offline Only)</li>
                                <li>💰Fee: ₹2,00,00</li>
                                <li>📌Locatio: Bhavana Singh Academy, Defence Colony, New Delh</li>
                                <li>🚨Seat: Limited to 12-15 for personalised attentio</li>
                              </ul>
                              <h3>Why This Program Is Different</h3>
                              <ul>
                                <li>Designed by a seasoned Personality & Image Transformation Coach</li>
                                <li>Built for those serious about launching a career or business in transformation, styling, or consulting</li>
                                <li>Focused on monetization, visibility, and professional execution</li>
                                <li>Includes 1:1 feedback and live projects with real-world application</li>
                              </ul>
                               <h3>Outcomes</h3>
                               <p>By the end of the program, you will:</p>
                              <ul>
                                <li>Walk with confidence, style, and clarity</li>
                                <li>Be ready to launch your own image consulting or transformation coaching business</li>
                                <li>Have the presence to influence rooms, interviews, and screens</li>
                                <li>Carry a professional portfolio ready for clients, brands, or media</li>
                                <li>Possess the tools to make a lasting impression — online and offline</li>
                              </ul>
                               <h3>Ready to Own the Room?</h3>
                             <p>This is your moment to go from ordinary to iconic.
 Tap into your potential. Build an unforgettable personal brand. And take the first step toward a career that reflects your boldest self</p>
                          </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="courses_image">
                        <img src={Image5} alt="" width="100%"/>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <section class="courses_sli">
        <div class="container">
            <div class="courses-slide">
                <div class="slide_head">
                    <h3>TRANSFORMATION IN FOCUS </h3>
                    <h2>Sneak Peek and Success Stories</h2>
                    <p>Get a firsthand look at the journey with real moments captured from our live sessions. Watch as confidence builds, style transforms, and true presence unfolds. These reels offer a glimpse into the powerful impact of our program in action.</p>
                </div>
            </div>
            <div class="swiper coursesslide">
                <div class="swiper-wrapper">
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video1)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image1}/><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video2)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image2}/><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video3)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image3}/><img className='playbtnv' src={Playbtn}></img></a></div>
                    <div class="swiper-slide"><a href="#" onClick={() => handleOpenModal(Video4)} data-bs-toggle="modal" data-bs-target="#videoModal"><img className="slideimg" src={Image4}/><img className='playbtnv' src={Playbtn}></img></a></div>
                   
                </div>
                <div>
                  <div className="testi-button-next swiper-button-next"></div>
                  <div className="testi-button-prev swiper-button-prev"></div>
                </div>
            </div>
            <div class="courses_btn">
                <a href="#" data-bs-toggle="modal" data-bs-target="#offlineonlyCourseModal">Enrol Now</a>
                <a href="https://drive.google.com/file/d/1Y6U__C-1UZ2BTb-8OW0ENaM9HUd2QzBt/view">Download Brochure</a>
            </div>
        </div>
      </section>
      
      </>
      ), },
  };

  const course = courses[id];

  

  useEffect(() => {
       
    if (window.Swiper) {
      
     

      const swiper = new window.Swiper(".coursesslide", {
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: ".testi-button-next",
          prevEl: ".testi-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 3, 
            spaceBetween: 30,
            navigation: {
              nextEl: ".testi-button-next",
              prevEl: ".testi-button-prev",
            },
          },
          // You can add more breakpoints if needed
        },
      
      });
       
     
    }
  }, []); 

  if (!course) {
    return <h2>404 not found</h2>;
  }

  return (
    <>
 <Helmet>
         <title>{course.meta?.title || course.title}</title>
         <meta name="description" content={course.meta?.description || ""} />
         <meta name="keywords" content={course.meta?.keywords || ""} />
       </Helmet>
    {course.content}

    <div className="modal fade" id="offlineCourseModal" tabIndex="-1" aria-labelledby="offlineCourseModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-body">
        <div className="formouter">
          <div className="formcontent">
            <form className="contact_form modalform">
              <h2>Pay for Offline Course</h2>
              <div className="row">
                <div className="col-sm-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="number"
                    name="phone"
                    className="form-control"
                    placeholder="Your Phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <button
                type="button"
                className="btn btn-form"
                onClick={() => handleRazorpayPayment("offline")}
              >
                Enrol Now
              </button>
            </form>
          </div>
          <div className="forminfo">
            <a href="tel:919899604722">
              <img src={Phoneicon} alt="" /> +91-9899604722
            </a>
            <a href="mailto:infobhavanasingh@gmail.com">
              <img src={Gmailicon} alt="" /> infobhavanasingh@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
    <div className="modal fade" id="offlineonlyCourseModal" tabIndex="-1" aria-labelledby="offlineonlyCourseModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-body">
        <div className="formouter">
          <div className="formcontent">
            <form className="contact_form modalform">
              <h2>Pay for Offline Course</h2>
              <div className="row">
                <div className="col-sm-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="number"
                    name="phone"
                    className="form-control"
                    placeholder="Your Phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <button
                type="button"
                className="btn btn-form"
                onClick={() => handleRazorpayPayment("Only Offline Course")}
              >
                Enrol Now
              </button>
            </form>
          </div>
          <div className="forminfo">
            <a href="tel:919899604722">
              <img src={Phoneicon} alt="" /> +91-9899604722
            </a>
            <a href="mailto:infobhavanasingh@gmail.com">
              <img src={Gmailicon} alt="" /> infobhavanasingh@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div className="modal fade" id="onlineCourseModal" tabIndex="-1" aria-labelledby="onlineCourseModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-body">
        <div className="formouter">
          <div className="formcontent">
            <form className="contact_form modalform">
              <h2>Pay for Online Course</h2>
              <div className="row">
                <div className="col-sm-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="number"
                    name="phone"
                    className="form-control"
                    placeholder="Your Phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <button
                type="button"
                className="btn btn-form"
                onClick={() => handleRazorpayPayment("online")}
              >
                Enrol Now
              </button>
            </form>
          </div>
          <div className="forminfo">
            <a href="tel:919899604722">
              <img src={Phoneicon} alt="" /> +91-9899604722
            </a>
            <a href="mailto:infobhavanasingh@gmail.com">
              <img src={Gmailicon} alt="" /> infobhavanasingh@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


      <div
        className={`modal fade ${activeVideo ? "show" : ""}`}
        id="videoModal"
        tabIndex="-1"
        aria-labelledby="videoModalLabel"
        aria-hidden={!activeVideo}
        style={{ display: activeVideo ? "block" : "none" }}
        onClick={(e) => {
          if (e.target.classList.contains("modal")) {
            handleCloseModal();
          }
        }}
      >
        <div className="modal-dialog modal-dialog-centered video_sectio">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="videoModalLabel">Bhavana Singh</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCloseModal}
              ></button>
            </div>
            <div className="modal-body">
              {activeVideo && (
                <iframe
                  id="videoFrame"
                  width="100%"
                  height="500"
                  src={`${activeVideo}#t=0&autoplay=1`}
                  frameBorder="0"
                  allow="autoplay"
                  allowFullScreen
                ></iframe>
              )}
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};

export default Coursessingle;
